import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAllJobGrades } from 'Api/masters/job-grade';

export const fetchJobGradeAction = createAsyncThunk(
	'jobGrade',
	async (params: any, { rejectWithValue }) => {
		try {
			const response = await getAllJobGrades(params);
			return response.data;
		} catch (error: any) {
			if (!error.response) {
				throw error;
			}
			return rejectWithValue(error?.response?.data);
		}
	}
);
